class ActuSlider {
	constructor($el) {
		this.$el = $el;

		this.options = {
            // autoPlay: true,
            draggable: true,
			pageDots: true,
			prevNextButtons: false,
			wrapAround: true,
			cellAlign: 'left',
			// groupCells: "100%",
			setGallerySize: false,
			cellSelector: ".slider-news__slide_item",
			prevNextButtons: true,
			selectedAttraction: 0.02,
			friction: 0.15,
			// cellalign: 'left',

		};

		if (this.$el.length) {
			this._createSlider();
		}
	}

	_createSlider() {
		this.$el.flickity(this.options);
	}
}

export default ActuSlider;
